import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { trackEvent } from '../utils/analytics';

export const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navItems = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Products', href: '#products' },
    { name: 'Experience', href: '#experience' },
    { name: 'Skills', href: '#skills' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'glass-header py-4' : 'py-6'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <a href="#home" className="flex items-center gap-3">
            <div className="relative">
              <img 
                src="/sd_logo_txt.png" 
                alt="Sudipta Dhara logo - Software Developer and Generative AI Engineer" 
                width={120}
                height={48}
                className="h-10 sm:h-11 md:h-12 w-auto object-contain logo-dark-mode" 
                loading="lazy" 
              />
            </div>
            <span className="text-xl font-semibold bg-gradient-to-r from-brand-gold1 to-brand-gold2 bg-clip-text text-transparent">Sudipta Dhara</span>
          </a>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <a 
                key={item.name}
                href={item.href}
                className="text-ink/80 hover:text-brand font-medium transition-colors"
                onClick={() => trackEvent(`nav-${item.name.toLowerCase()}`)}
                data-umami-event={`nav-${item.name.toLowerCase()}`}
              >
                {item.name}
              </a>
            ))}
          </nav>
          
          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-ink hover:text-brand"
            onClick={() => {
              toggleMenu();
              trackEvent(isOpen ? 'mobile-menu-close' : 'mobile-menu-open');
            }}
            aria-label="Toggle menu"
            data-umami-event={isOpen ? 'mobile-menu-close' : 'mobile-menu-open'}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      {/* Mobile Navigation */}
      <div className={`md:hidden ${isOpen ? 'block' : 'hidden'}`}>
        <div className="px-4 py-2 glass">
          {navItems.map((item) => (
            <a 
              key={item.name}
              href={item.href}
              className="block py-3 text-ink/80 hover:text-brand font-medium transition-colors"
              onClick={() => {
                setIsOpen(false);
                trackEvent(`mobile-nav-${item.name.toLowerCase()}`);
              }}
              data-umami-event={`mobile-nav-${item.name.toLowerCase()}`}
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
};
